interface StatItem {
    value: string;
    label: string;
  }
  
  export default function Stats() {
    const stats: StatItem[] = [
      { value: '15+', label: 'Years Experience' },
      { value: '200+', label: 'Client Projects' },
      { value: '98%', label: 'Client Retention' },
    ];
  
    return (
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="text-center p-6 hover:shadow-lg transition-shadow duration-300 rounded-lg"
              >
                <p className="text-5xl font-bold text-hatom-blue-900 mb-2">
                  {stat.value}
                </p>
                <p className="text-gray-600 uppercase text-sm tracking-wider">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }